module.exports = __webpack_public_path__ + "static/media/2.98fbe247.jpg";